import { Column, Flex, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import gotuMonogram from '~/images/logos/logoLightIcon.svg';
import { TestimonialsCarousel } from './TestimonialsCarousel';
import type { ITestimonial, IValueProp } from './types';

export interface IAuthLeftPanelProps {
  headline: { lineOne: string; lineTwo: string };
  valueProps: IValueProp[];
  testimonials: ITestimonial[];
  autoPlayMs?: number;
}

// Gradient stops don't exist in the token scale; last stop matches colors.primary[500].
const GRADIENT_BG =
  'linear-gradient(180deg, #1E4C58 0%, #225664 13%, #2A6B7E 46%, #2F7A8D 76%, #307F92 100%)';

const PANEL_PADDING = '62px 84px 40px 84px';
const TAGLINE_TO_VALUE_PROPS_GAP = 51;
const VALUE_PROPS_TO_TESTIMONIAL_GAP = 60;
const VALUE_PROP_INTERNAL_GAP = 10;

export const AuthLeftPanel = ({
  headline,
  valueProps,
  testimonials,
  autoPlayMs,
}: IAuthLeftPanelProps) => (
  <Column
    height="100%"
    style={{ background: GRADIENT_BG, padding: PANEL_PADDING }}
    data-testid="auth-left-panel"
  >
    <Row gap={6} align="center">
      <img src={gotuMonogram} alt="" width={110} height={112} />
      <Typography as="h1" bold color={colors.shades[0]} style={{ fontSize: 48, lineHeight: 1.25 }}>
        <span style={{ display: 'block' }}>{headline.lineOne}</span>
        <span style={{ display: 'block', color: colors.secondary[500] }}>{headline.lineTwo}</span>
      </Typography>
    </Row>

    <Column gap={VALUE_PROP_INTERNAL_GAP} style={{ marginTop: TAGLINE_TO_VALUE_PROPS_GAP }}>
      {valueProps.map((vp, index) => (
        <Row key={index} align="start" gap={4}>
          <Flex style={{ color: colors.secondary[400], flexShrink: 0 }}>{vp.icon}</Flex>
          <Typography
            size="heading_4"
            bold
            color={colors.shades[0]}
            style={{ marginTop: 4, lineHeight: 1.25 }}
          >
            {vp.text}
          </Typography>
        </Row>
      ))}
    </Column>

    <div
      style={{
        width: '100%',
        marginTop: VALUE_PROPS_TO_TESTIMONIAL_GAP,
      }}
    >
      <TestimonialsCarousel testimonials={testimonials} autoPlayMs={autoPlayMs} />
    </div>
  </Column>
);
